import { getContext } from '@/assets/js/mapContext';

let mapStatesStash = [];

export default {
  methods: {
    saveMapState(map) {
      if (!map) return;
      mapStatesStash = [map, ...mapStatesStash];
    },
    restoreMapState(callback) {
      if (!mapStatesStash.length) return;
      callback(mapStatesStash.shift());
    },
  },
  beforeDestroy() {
    mapStatesStash = [];
  },
  created() {
    mapStatesStash = [];
    getContext(this).$off('saveMapState');
    getContext(this).$on('saveMapState', this.saveMapState);

    getContext(this).$off('restoreMapState');
    getContext(this).$on('restoreMapState', this.restoreMapState);
  },
};
